module.exports = __webpack_public_path__ + "img/gi_galiyuk.a0e5b519.png";